import { Route } from '@angular/router';
import { SecureComponent } from './secure.component';
import { authGuard } from '../../guards/auth.guard';
import { coordinatorGuard } from '../../guards/auth.coordintator.guard';
import { coordinatorRegionalGuard } from '../../guards/auth.coordintator.regional.guard';
import { governanceGuard } from '../../guards/auth.governance.guard';

export const secureRoutes: Route[] = [
  {
    path: 'secure',
    component: SecureComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'settings',
        children: [
          {
            path: 'plant-list',
            canActivate: [coordinatorGuard],
            loadComponent: () =>
              import('./plant-management/plant-list/plant-list.component').then(
                (m) => m.PlantListComponent,
              ),
          },
          {
            path: 'plant-access/:id',
            canActivate: [coordinatorGuard],
            loadComponent: () =>
              import('./plant-management/plantConfig/access-management/access-management.component').then(
                (m) => m.AccessManagementComponent,
              ),
          },
          {
            path: 'plant-settings/:id',
            canActivate: [coordinatorGuard],
            loadComponent: () =>
              import('./plant-management/plant-management/plant-management.component').then(
                (m) => m.PlantManagementComponent,
              ),
          },
          {
            path: 'access-management',
            canActivate: [coordinatorGuard],
            loadComponent: () =>
              import('./plant-management/user-access/user-access.component').then(
                (m) => m.UserAccessComponent,
              ),
          }
        ]
      },
      {
        path: 'master-data',
        canActivate: [coordinatorGuard],
        children: [
          {
            path: 'supplier-list',
            loadComponent: () =>
              import('./master-data/supplier-list/supplier-list.component').then(
                (m) => m.SupplierListComponent,
              ),
          },
          {
            path: 'plant-list',
            loadComponent: () =>
              import('./master-data/plant-list/plant-list.component').then(
                (m) => m.PlantListComponent,
              ),
          },

          {
            path: 'bus-line-list',
            loadComponent: () =>
              import('./master-data/bus-line-list/bus-line-list.component').then(
                (m) => m.BusLineListComponent,
              ),
          },
          {
            path: 'bus-line-versions/:id',
            loadComponent: () =>
              import('./master-data/bus-line-versions/bus-line-versions.component').then(
                (m) => m.BusLineVersionsComponent,
              ),
          },
          {
            path: 'version-route-builder/:busLineId/:sourceVersionId',
            loadComponent: () =>
              import('./master-data/version-route-builder/version-route-builder.component').then(
                (m) => m.VersionRouteBuilderComponent,
              ),
          },
          {
            path: 'bus-stop-list',
            loadComponent: () =>
              import('./master-data/bus-stop-list/bus-stop-list.component').then(
                (m) => m.BusStopListComponent,
              ),
          },
          {
            path: 'price-sheet-list',
            loadComponent: () =>
              import('./master-data/price-sheet-list/price-sheet-list.component').then(
                (m) => m.PriceSheetListComponent,
              ),
          },
          {
            path: 'region-list',
            loadComponent: () =>
              import('./master-data/region-list/region-list.component').then(
                (m) => m.RegionListComponent,
              ),
          },
          {
            path: 'country-list',
            loadComponent: () =>
              import('./master-data/country-list/country-list.component').then(
                (m) => m.CountryListComponent,
              ),
          },
          {
            path: 'vehicle-list',
            loadComponent: () =>
              import('./master-data/vehicle-list/vehicle-list.component').then(
                (m) => m.VehicleListComponent,
              ),
          },
        ],
      },

      {
        path: 'call-off',
        canActivate: [coordinatorGuard],
        children: [
          {
            path: 'overview',
            loadComponent: () =>
              import('./call-off/overview/overview.component').then(
                (m) => m.OverviewComponent,
              ),
          },
          {
            path: 'new-call-of',
            loadComponent: () =>
              import('./call-off/call-off-creation/call-off-creation.component').then(
                (m) => m.CallOffCreationComponent,
              ),
          },
          {
            path: 'bus-entry-report',
            loadComponent: () =>
              import('./overview/bus-entry-report/bus-entry-report.component').then(
                (m) => m.BusEntryReportComponent,
              ),
          },
        ],
      },
      {
        path: 'call-off-list',
        canActivate: [coordinatorGuard],
        loadComponent: () =>
          import('./call-off/call-off-list/call-off-list.component').then(
            (m) => m.CallOffListComponent,
          ),
      },
      {
        path: 'call-off/call-off-creation',
        canActivate: [coordinatorGuard],
        loadComponent: () =>
          import('./call-off/call-off-creation/call-off-creation.component').then(
            (m) => m.CallOffCreationComponent,
          ),
      },
      {
        path: 'call-off/call-off-creation/:id',
        canActivate: [coordinatorGuard],
        loadComponent: () =>
          import('./call-off/call-off-creation/call-off-creation.component').then(
            (m) => m.CallOffCreationComponent,
          ),
      },
      {
        path: 'call-off/call-off-analysis/:id',
        canActivate: [coordinatorGuard],
        loadComponent: () =>
          import('./call-off/call-off-analysis/call-off-analysis.component').then(
            (m) => m.CallOffAnalysisComponent,
          ),
      },
      {
        path: 'call-off/call-off-analysis/:id/:isEditable',
        canActivate: [coordinatorGuard],
        loadComponent: () =>
          import('./call-off/call-off-analysis/call-off-analysis.component').then(
            (m) => m.CallOffAnalysisComponent,
          ),
      },
      {
        path: 'call-off/special-cost/:id',
        loadComponent: () =>
          import('./call-off/special-cost/special-cost.component').then(
            (m) => m.SpecialCostComponent,
          ),
      },
      {
        path: 'employee',
        canActivate: [authGuard],
        children: [
          {
            path: 'employee-portal-home',
            loadComponent: () =>
              import('./employee-portal/employee-portal-home/employee-portal-home.component').then(
                (m) => m.EmployeePortalHomeComponent,
              ),
          },
          {
            path: 'bus-line-info',
            loadComponent: () =>
              import('./employee-portal/bus-line-overview/bus-line-overview.component').then(
                (m) => m.BusLineOverviewComponent,
              ),
          },
          {
            path: 'book-bus-route',
            loadComponent: () =>
              import('./employee-portal/book-bus-route/book-bus-route.component').then(
                (m) => m.BookBusRouteComponent,
              ),
          },
          {
            path: 'book-bus-route-overview-employee',
            loadComponent: () =>
              import('./employee-portal/book-bus-route-overview-employee/book-bus-route-overview-employee.component').then(
                (m) => m.BookBusRouteOverviewEmployeeComponent,
              ),
          },
          {
            path: 'overview-booked-routes',
            loadComponent: () =>
              import('./employee-portal/overview-booked-routes/overview-booked-routes.component').then(
                (m) => m.OverviewBookedRoutesComponent,
              ),
          },
          {
            path: 'bus-tracking',
            loadComponent: () =>
              import('./employee-portal/bus-tracking/bus-tracking.component').then(
                (m) => m.BusTrackingComponent,
              ),
          },
          {
            path: 'gps-overview',
            loadComponent: () =>
              import('./employee-portal/gps-overview/gps-overview.component').then(
                (m) => m.GpsOverviewComponent,
              ),
          }
        ],
      },
      {
        path: 'bus-checker',
        canActivate: [coordinatorGuard],
        children: [
          {
            path: 'bus-check-start',
            loadComponent: () =>
              import('./bus-checker/bus-check-start/bus-check-start.component').then(
                (m) => m.BusCheckStartComponent,
              ),
          },
          {
            path: 'bus-check-overview',
            loadComponent: () =>
              import('./bus-checker/bus-check-overview/bus-check-overview.component').then(
                (m) => m.BusCheckOverviewComponent,
              ),
          },
          {
            path: 'bus-check-incidents',
            loadComponent: () =>
              import('./bus-checker/bus-check-incidents/bus-check-incidents.component').then(
                (m) => m.BusCheckIncidentsComponent,
              ),
          },
          {
            path: 'bus-check-list',
            canActivate: [governanceGuard],
            loadComponent: () =>
              import('./bus-checker/bus-check-list/bus-check-list.component').then(
                (m) => m.BusCheckListComponent,
              ),
          },
          {
            path: 'bus-check-start-options',
            loadComponent: () =>
              import('./bus-checker/bus-check-start-options/bus-check-start-options.component').then(
                (m) => m.BusCheckStartOptionsComponent,
              ),
          },
          {
            path: 'bus-check-checkpoints',
            loadComponent: () =>
              import('./bus-checker/bus-check-checkpoints/bus-check-checkpoints.component').then(
                (m) => m.BusCheckCheckpointsComponent,
              ),
          }
        ],
      },
      {
        path: 'overview',
        canActivate: [coordinatorGuard],
        children: [
          {
            path: 'bus-arrival',
            loadComponent: () =>
              import('./overview/bus-arrival/bus-arrival.component').then(
                (m) => m.BusArrivalComponent,
              ),
          },
          {
            path: 'employee-bus-line',
            loadComponent: () =>
              import('./overview/employee-bus-line/employee-bus-line.component').then(
                (m) => m.EmployeeBusLineComponent,
              ),
          },
          {
            path: 'occupancy-rate',
            loadComponent: () =>
              import('./overview/overview-occupancy-rate/overview-occupancy-rate/overview-occupancy-rate.component').then(
                (m) => m.OverviewOccupancyRateComponent,
              ),
          },
        ]
      },
      {
        path: 'route-planning',
        canActivate: [coordinatorGuard],
        children: [
          {
            path: 'home',
            loadComponent: () =>
              import('./route-planning/route-planning-home/route-planning-home.component').then(
                (m) => m.RoutePlanningHomeComponent,
              ),
          },
          {
            path: 'route-builder',
            loadComponent: () =>
              import('./route-planning/route-builder/route-builder.component').then(
                (m) => m.RouteBuilderComponent,
              ),
          },
          {
            path: 'route-builder/:id',
            loadComponent: () => import('./route-planning/route-builder/route-builder.component').then((m) => m.RouteBuilderComponent),
          },
          {
            path: 'route-builder-from-file',
            loadComponent: () => import('./route-planning/route-builder-employee-list/route-builder-employee-list.component').then((m) => m.RouteBuilderEmployeeListComponent),
          },
          {
            path: 'route-cluster',
            loadComponent: () => import('./route-planning/route-clustering/route-clustering.component').then((m) => m.RouteClusteringComponent),
          },
          {
            path: 'route-sandbox',
            loadComponent: () => import('./route-planning/prospected-routes/prospected-routes.component').then((m) => m.ProspectedRoutesComponent),
          },
          {
            path: 'optimize-route',
            loadComponent: () =>
              import('./route-planning/optimize-route/optimize-route.component').then(
                (m) => m.OptimizeRouteComponent,
              ),
          },
          {
            path: 'optimize-route/:id',
            loadComponent: () =>
              import('./route-planning/optimize-route/optimize-route.component').then(
                (m) => m.OptimizeRouteComponent,
              ),
          },
          {
            path: 'special-routes',
            loadComponent: () =>
              import('./route-planning/special-routes/create-special-route/create-special-route.component').then(
                (m) => m.CreateSpecialRouteComponent,
              ),
          },
          {
            path: 'listing-bus-lines',
            loadComponent: () =>
              import('./route-planning/_components/listing-bus-lines/listing-bus-lines.component').then(
                (m) => m.ListingBusLinesComponent,
              ),
          },
          {
            path: 'all-routes-map',
            loadComponent: () =>
              import('./route-planning/all-routes-map/all-routes-map.component').then(
                (m) => m.AllRoutesMapComponent,
              ),
          }
        ]
      },
      {
        path: 'special-call-off',
        canActivate: [coordinatorGuard],
        children: [
          {
            path: 'creation',
            loadComponent: () =>
              import('./special-call-off/special-call-off-creation/special-call-off-creation.component').then(
                (m) => m.SpecialCallOffCreationComponent,
              ),
          },
          {
            path: 'summary',
            loadComponent: () =>
              import('./special-call-off/summary/summary.component').then(
                (m) => m.SpecialCallOffSummaryComponent
              ),
          },
          {
            path: 'regular-routes/:id',
            loadComponent: () =>
              import('./special-call-off/regular-routes/regular-routes.component').then(
                (m) => m.RegularRoutesComponent
              ),
          },
          {
            path: 'special-transport/:id',
            loadComponent: () =>
              import('./special-call-off/special-transport/special-transport.component').then(
                (m) => m.SpecialTransportComponent
              ),
          },
          {
            path: 'special-analysis/:id',
            loadComponent: () =>
              import('./special-call-off/special-analysis/special-analysis.component').then(
                (m) => m.SpecialAnalysisComponent
              ),
          },
        ]
      },
      {
        path: 'landing',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./landing/landing.component').then(
            (m) => m.LandingComponent,
          ),
      },
      {
        path: 'unauthorized',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./_components/unauthorized-screen/unauthorized-screen.component').then(
            (m) => m.UnauthorizedScreenComponent,
          ),
      },
      {
        path: '**',
        redirectTo: 'landing',
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: 'landing',
        pathMatch: 'full',
      },
    ],
  },
];

function providerHttpClient(): import("@angular/core").Provider | import("@angular/core").EnvironmentProviders {
  throw new Error('Function not implemented.');
}
